module.exports = __webpack_public_path__ + "static/media/pastor-slide.f24d6691.jpg";